module.exports = __webpack_public_path__ + "img/Deuil.1fa95c0.jpg";